import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { VerifyClientList } from "../models/client/verify/verifyClientList";
import { GenericClientRequestDto } from "../models/client/genericClientRequestDto";

@Injectable({
  providedIn: "root",
})
export class ClientsListingService {
  private clientManagementBaseURL = environment.baseUrl + "/ClientManagement";
  public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(private _http: HttpClient) {}

  getClientList(
    status: string
  ): Observable<GenericResponseDto<VerifyClientList[]>> {
    return this._http.get<GenericResponseDto<VerifyClientList[]>>(
      this.clientManagementBaseURL + "/GetAllClients?ClientStatus=" + status
    );
  }

  getClientListUnprotectedDays(
    status: string,
    unprotectedDays: string
  ): Observable<GenericResponseDto<VerifyClientList[]>> {
    return this._http.get<GenericResponseDto<VerifyClientList[]>>(
      this.clientManagementBaseURL +
        `/GetAllClients?ClientStatus=${status}&unprotectedDays=${unprotectedDays}`
    );
  }

  getClientListing(
    payload: GenericClientRequestDto
  ): Observable<GenericResponseDto<VerifyClientList[]>> {
    return this._http.post<GenericResponseDto<VerifyClientList[]>>(
      this.clientManagementBaseURL + `/GetClientsListing`,
      payload
    );
  }

  setAttachmentState(value: boolean) {
    this.status.next(value);
  }

  GetAllInActiveClientsList(
    status: string
  ): Observable<GenericResponseDto<VerifyClientList[]>> {
    return this._http.get<GenericResponseDto<VerifyClientList[]>>(
      this.clientManagementBaseURL +
        "/GetAllInActiveClients?ClientStatus=" +
        status
    );
  }
}
